<template>
  <div
    class="m-dropdown-content m-dropdown-content-left"
    id="MoleculeEditionBillingMyPaymentsDropDownFilters"
  >
    <section
      v-if="showLoadingState < 2"
      key="loadingState"
      class="m-dropdown-section"
    >
      <ul class="m-dropdown-list">
        <li>
          <a
            href="#"
            @click.prevent=""
          >
            <AtomLoadingSecondary/>
          </a>
        </li>
      </ul>
    </section>
    <form
      v-else
      key="billingMyShoppingDropDownFilters"
      autocomplete="off"
      name="MyPaymentsDropDownFilters"
      spellcheck="false"
      @submit.prevent="searchAdvancedFilter"
    >
      <section class="m-dropdown-section">
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              {{ $t('mEditionBillingMyShoppingDropDownFilters.input.tiposDeCompra.label') }}
            </a>
            <div class="m-dropdown-sublist display-flex-row">
              <AtomRadioButtonPrimary
                v-model.number="filter.free_shopp"
                :radio-button-primary="radioButtonPrimary.freeShopp"
                :text="$filters.parameters.typesOfShopp[1].name"
                :value="$filters.parameters.typesOfShopp[1].id"
                wrapperClass="a-input-side margin-top-xsmall margin-bottom-xsmall"
              />
              <AtomRadioButtonPrimary
                v-model.number="filter.free_shopp"
                :radio-button-primary="radioButtonPrimary.freeShopp"
                :text="$filters.parameters.typesOfShopp[0].name"
                :value="$filters.parameters.typesOfShopp[0].id"
                wrapperClass="a-input-side margin-top-xsmall margin-bottom-xsmall"
              />
            </div>
          </li>
        </ul>
        <ul
          v-if="!(+filter.free_shopp)"
          class="m-dropdown-list"
        >
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              {{ $t('mEditionBillingMyShoppingDropDownFilters.input.estado.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <ul>
                <li
                  v-for="(estado, index) in estadosPagos"
                  :key="index"
                >
                  <AtomCheckboxPrimary
                    v-model="filter.estado"
                    inputStyle="academy"
                    name="estado"
                    :text="estado.name"
                    :value="estado.id"
                    wrapper-class="margin-zero"
                  />
                </li>
              </ul>
            </div>
          </li>
        </ul>
        <ul
          v-if="!(+filter.free_shopp)"
          class="m-dropdown-list"
        >
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              {{ $t('mEditionBillingMyShoppingDropDownFilters.input.divisa.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <ul>
                <li
                  v-for="(divisa, index) in divisas"
                  :key="index"
                >
                  <AtomCheckboxPrimary
                    v-model="filter.divisa"
                    inputStyle="academy"
                    name="moneda"
                    :text="divisa.nombre"
                    :value="divisa.id_divisa"
                    wrapper-class="margin-zero"
                  />
                </li>
              </ul>
            </div>
          </li>
        </ul>
        <ul
          v-if="!(+filter.free_shopp)"
          class="m-dropdown-list"
        >
          <li>
            <a href="#">
              {{ $t('mEditionBillingMyShoppingDropDownFilters.input.medioPago.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <ul>
                <li
                  v-for="(pasarela, index) in pasarelas"
                  :key="index"
                >
                  <AtomCheckboxPrimary
                    v-model="filter.pasarela_pago"
                    inputStyle="academy"
                    name="medio"
                    :text="pasarela.nombre"
                    :value="pasarela.id"
                    wrapper-class="margin-zero"
                  />
                </li>
              </ul>
            </div>
          </li>
        </ul>
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              {{ $t('mEditionBillingMyShoppingDropDownFilters.input.fechaDesde.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <AtomDatePicker
                v-model="filter.fecha_desde"
                label=""
                name="fecha_desde"
                :placeholder="$t('mEditionBillingMyShoppingDropDownFilters.input.fechaDesde.placeholder')"
              />
            </div>
          </li>
        </ul>
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              {{ $t('mEditionBillingMyShoppingDropDownFilters.input.fechaHasta.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <AtomDatePicker
                v-model="filter.fecha_hasta"
                :disabled-dates="disabledDates"
                name="fecha_hasta"
                :placeholder="$t('mEditionBillingMyShoppingDropDownFilters.input.fechaHasta.placeholder')"
              />
            </div>
          </li>
        </ul>
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              {{ $t('mEditionBillingMyShoppingDropDownFilters.input.descuento.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <input
                v-model="filter.cupon"
                class="a-input-primary"
                name="descuento"
                :placeholder="$t('mEditionBillingMyShoppingDropDownFilters.input.descuento.placeholder')"
                type="text"
              >
            </div>
          </li>
        </ul>
      </section>
      <footer class="m-dropdown-footer">
        <button
          class="a-button-dropdown-secondary"
          @click="reloadListing"
        >
          {{ $t('mEditionBillingMyShoppingDropDownFilters.buttons.btnReiniciarText') }}
        </button>
        <button
          :class="btnClass"
          type="submit"
        >
          {{ $t('mEditionBillingMyShoppingDropDownFilters.buttons.btnFilterText') }}
        </button>
      </footer>
    </form>
  </div>
</template>
<script>
export default {
  name: 'MoleculeEditionBillingMyShoppingDropDownFilters',

  props: {
    filterSeted: Object
  },

  data () {
    return {
      btnClass: '',
      disabledDates: {
        to: ''
      },

      divisas: [],
      estadosPagos: [],

      filter: {
        estado: [],
        divisa: [],
        pasarela_pago: [],
        fecha_desde: '',
        fecha_hasta: '',
        free_shopp: '',
        cupon: '',
        pagina: 1,
        limite: 10
      },

      pasarelas: [],
      radioButtonPrimary: {
        freeShopp: {
          labelClass: '',
          name: 'free-sale'
        }
      },
      showLoadingState: 0,
      tipoComprobantes: []
    }
  },

  computed: {
    academyDataColor () {
      return this.$store.getters.getAcademyData.color
    }
  },

  watch: {
    'filter.fecha_desde' () {
      if (this.$moment(this.filter.fecha_desde).isAfter(this.filter.fecha_hasta)) {
        this.filter.fecha_hasta = null
      }

      this.disabledDates = {
        to: this.filter.fecha_desde
      }
    },

    'filter.free_shopp' () {
      if (+this.filter.free_shopp) {
        this.filter.estado = []
        this.filter.divisa = []
        this.filter.pasarela_pago = []
      }
    },

    filterSeted: {
      deep: true,

      handler () {
        this.filter.cupon = this.filterSeted.cupon
        this.filter.divisa = [...this.filterSeted.divisa]
        this.filter.estado = [...this.filterSeted.estado]
        this.filter.free_shopp = this.filterSeted.free_shopp
        this.filter.fecha_desde = this.filterSeted.fecha_desde
        this.filter.fecha_hasta = this.filterSeted.fecha_hasta
        this.filter.pasarela_pago = [...this.filterSeted.pasarela_pago]

        this.disabledDates = {
          to: this.filter.fecha_desde
        }
      },

      immediate: true
    }
  },

  created () {
    if (this.academyDataColor) {
      this.btnClass = 'a-button-primary a-button-academy-primary a-button-dropdown-primary'
      this.radioButtonPrimary.freeShopp.labelClass = 'a-radiobutton-academy-primary font-size-small'
    } else {
      this.btnClass = 'a-button-primary a-button-billing-primary a-button-dropdown-primary'
      this.radioButtonPrimary.freeShopp.labelClass = 'a-radiobutton-billing-primary font-size-small'
    }
    this.estadosPagos = [...this.$filters.parameters.salesStates]
    this.estadosPagos.shift()
    this.readDivisas()
    this.readPasarelasPagoActivas()
  },

  methods: {
    readDivisas () {
      this.$services.read('divisa', 'readDivisas')
        .then(response => {
          this.divisas = response.data
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    readPasarelasPagoActivas () {
      this.$services.read('pasarela', 'readPasarelas')
        .then(response => {
          this.pasarelas = response.data
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    reloadListing () {
      this.$emit('reloadListing')
    },

    searchAdvancedFilter () {
      this.$dropDown.switchDropDown('MoleculeEditionBillingMyPaymentsDropDownFilters')
      this.$emit('searchAdvancedFilter', this.filter)
    }
  }
}
</script>
